module.exports = "<div class=\"progress\"\n     *ngIf=\"isSpinnerVisible\">\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n</div>\n"